import React, { Fragment } from "react"
import { GAME_DESCRIPTION } from "./CONTENT"

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function GameDescription(): any {
  return (
    <Fragment>
      <h3>{GAME_DESCRIPTION.title}</h3>
      {GAME_DESCRIPTION.description.map((desc, id) => (
        <p key={id}>{desc}</p>
      ))}
      <br />
    </Fragment>
  )
}
